<div class="modal-header modal-h">
  <h5 class="modal-title">{{ 'DETAILS.DIALOG.PENSION.TITLE' | translate }}</h5>
  <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button></div>

<div class="modal-b">
  <form [formGroup]="form" class="pension-form">
    <div class="form-group">
      <label for="contribution" class="form-label">
        {{ 'DETAILS.DIALOG.PENSION.CONTRIBUTION_LABEL' | translate }}
      </label>
      <div class="input-group">
        <input
          #contributionInput 
          type="number" 
          class="form-control" 
          id="contribution"
          formControlName="contribution" 
          min="0"
          placeholder="0"
          [class.is-invalid]="contributionControl.invalid && contributionControl.touched">
        <div class="input-group-append">
          <span class="input-group-text">RON</span>
        </div>
      </div>
      <small class="form-text text-muted">
        {{ 'DETAILS.DIALOG.PENSION.HINT' | translate }}
      </small>
      <div class="invalid-feedback" *ngIf="hasError('required')">
        {{ 'DETAILS.DIALOG.PENSION.ERROR_REQUIRED' | translate }}
      </div>
      <div class="invalid-feedback" *ngIf="hasError('min')">
        {{ 'DETAILS.DIALOG.PENSION.ERROR_MIN' | translate }}
      </div>
    </div>

    <div class="alert alert-info d-flex align-items-start mt-3">
      <i class="feather icon-info mr-2"></i>
      <small>{{ 'DETAILS.DIALOG.PENSION.INFO_TEXT' | translate }}</small>
    </div>

    <div class="alert alert-warning d-flex align-items-start mt-2">
      <i class="feather icon-alert-triangle mr-2"></i>
      <small>{{ 'DETAILS.DIALOG.PENSION.NN_AGREEMENT_TEXT' | translate }}</small>
    </div>
  </form>

  <div class="delete-section">
    <button 
      class="btn btn-link text-danger" 
      (click)="onDelete()">
      <i class="feather icon-trash-2 mr-1"></i>
      {{ 'DETAILS.DIALOG.BUTTONS.DELETE_CONTRIBUTION' | translate }}
    </button>
  </div>

  <div class="d-flex buttons justify-content-end">
    <button 
      class="btn btn-secondary mr-2" 
      (click)="closeBtnClick()">
      {{ 'DETAILS.DIALOG.BUTTONS.CANCEL' | translate }}
    </button>
    
    <button 
      class="btn btn-primary" 
      (click)="onSave()" 
      [disabled]="form.invalid">
      <i class="feather icon-check-square mr-1"></i>
      {{ 'DETAILS.DIALOG.BUTTONS.SAVE' | translate }}
    </button>
  </div>
</div>